import React, {memo} from 'react';
import Layout from '../components/Layout';
import GlobalAuthorizationLayout from '../components/GlobalAuthorizationLayout';
import Tasks from '../apps/Tasks';
import CheckStaffUserLayout from '../layout/CheckStaffUserLayout';
import CheckViewer from '../layout/CheckViewer';

const TaskPage: React.FC = () => {
    return (
        <GlobalAuthorizationLayout>
            <CheckStaffUserLayout>
                <CheckViewer>
                <Layout>
                        <Tasks/>
                </Layout>
                </CheckViewer>
            </CheckStaffUserLayout>
        </GlobalAuthorizationLayout>
    );
};

export default memo(TaskPage);
